import type { Product } from '../pages/CatalogPage';

// Custom sort order for payment methods in Supported Payments tab
export const sortPaymentMethods = (products: Product[]) => {
  const paymentOrder = [
    'Visa',
    'Mastercard',
    'Amex',
    'Diners',
    'Discover',
    'JCB',
    'UPI',
    'US Debit',
    'Interac',
    'AliPay',
    'Apple Pay',
    'Google Pay',
    'Mobile Pay',
    'Gift Cards',
    'ACH',
    'Pay with Crypto',
    '3D Secure',
    'Network Tokenization',
    'Dynamic Currency Conversion (DCC)',
  ];

  return [...products].sort((a, b) => {
    const indexA = paymentOrder.findIndex(pm =>
      a.solution.toLowerCase().includes(pm.toLowerCase())
    );
    const indexB = paymentOrder.findIndex(pm =>
      b.solution.toLowerCase().includes(pm.toLowerCase())
    );

    // If both are in the priority list, sort by priority order
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    // If only A is in the list, it comes first
    if (indexA !== -1) return -1;

    // If only B is in the list, it comes first
    if (indexB !== -1) return 1;

    // If neither is in the list, sort alphabetically
    return a.solution.localeCompare(b.solution);
  });
};
